var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"router":"","mode":"horizontal","default-active":_vm.path}},_vm._l((_vm.vuex_menu),function(item,key){return _c('el-menu-item',{key:key,attrs:{"index":item.path}},[_c('i',{class:item.icon,staticStyle:{"font-weight":"600"}}),_vm._v(" "+_vm._s(item.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }